import axios from 'axios';
import BaseApi from './base-api';
import { TYPES } from 'services/utils/users-util';

export class UsersApi extends BaseApi {
  removeUser(id) {
    return axios
      .delete(`${this.baseUrl}/users/${id}`)
      .then(() => {
        return {
          ok: true,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  getUsers() {
    return axios
      .get(`${this.baseUrl}/users`)
      .then((response) => {
        return {
          ok: true,
          users: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  addUser(
    firstName,
    lastName,
    email,
    phoneNumber = null,
    rolesId,
    title = null,
    buildingsId = null
  ) {
    const data = this.createAddEditUserData(
      firstName,
      lastName,
      email,
      phoneNumber,
      rolesId,
      title,
      buildingsId
    );

    return axios
      .post(`${this.baseUrl}/users`, data)
      .then((response) => {
        return {
          ok: true,
          user: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  updateUser(
    id,
    firstName,
    lastName,
    email,
    phoneNumber = null,
    rolesId,
    title = null,
    buildingId = null
  ) {
    const data = this.createAddEditUserData(
      firstName,
      lastName,
      email,
      phoneNumber,
      rolesId,
      title,
      buildingId
    );

    return axios
      .put(`${this.baseUrl}/users/${id}`, data)
      .then((response) => {
        return {
          ok: true,
          user: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  createAddEditUserData(
    firstName,
    lastName,
    email,
    phoneNumber = null,
    rolesId,
    title = null,
    buildingsId = null
  ) {
    const data = {
      user: {
        email: email,
        first_name: firstName,
        last_name: lastName,
        role_ids: rolesId,
      },
    };

    if (phoneNumber !== null && phoneNumber !== '') {
      data.user['phone_number'] = phoneNumber;
    }

    if (title !== null && title !== '') {
      data.user['title'] = title;
    }

    if (buildingsId !== null) {
      data.user['building_ids'] = buildingsId;
    }

    return data;
  }

  updateTermsAndConditions(isAccepted) {
    return axios
      .put(`${this.baseUrl}/user/terms_and_conditions`, {
        user: { terms_and_conditions: isAccepted },
      })
      .then((response) => {
        return {
          ok: true,
          data: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  resendInvite(userId) {
    return axios
      .put(`${this.baseUrl}/users/${userId}/resend_invite`, {
        id: userId,
      })
      .then((response) => {
        return {
          ok: true,
        };
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }

  resendInviteLink(currentUser, user) {
    if (user.invitation_accepted_at !== null) {
      return false;
    } else if (
      currentUser.accountable_type == null ||
      currentUser.accountable_type === TYPES.GENERAL_CONTRACTOR
    ) {
      return true;
    } else {
      return currentUser.accountable_type === user.accountable_type;
    }
  }
}

export let usersApi = new UsersApi();
export default UsersApi = new UsersApi();



// WEBPACK FOOTER //
// ./src/services/api/users-api.js